import * as React from 'react';
import { Form, Input } from 'antd';

const style = require('./LocationAutocomplete.less');

interface LocationFreeFormProps {
	placeholder?: string;
	value?: {
		streetAddress1?: string;
		streetAddress2Opt?: string;
		city?: string;
		region?: string;
		postcode?: string;
		country?: string;
	};
	onChange?: (value: any) => void;
	onBlur?: () => void;
}

const LocationFreeForm: React.FC<LocationFreeFormProps> = (props) => {
	const { placeholder, value = {}, onChange, onBlur } = props;
	const { streetAddress1, streetAddress2Opt, city, region, postcode, country } = value;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onChange({ ...value, [e.target.name]: e.target.value });
	};

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		if (onBlur) {
			onBlur();
		}
	};

	return (
		<div className="space-y-4">
			<div className="flex flex-row gap-x-4">
				<Input
					name="streetAddress1"
					value={streetAddress1}
					onChange={handleChange}
					onBlur={handleBlur}
					placeholder={placeholder}
					className="location-search-input mt-1 block w-full"
					autoComplete="random"
				/>
				<Input
					placeholder="PO#, Apt, suite, unit, building, floor, etc."
					name="streetAddress2Opt"
					value={streetAddress2Opt}
					onChange={handleChange}
					onBlur={handleBlur}
					className="mt-1 block w-full"
				/>
			</div>

			<div className="flex flex-row gap-x-2">
				<div className="flex-1">
					<label className=" mb-1 block text-sm  text-gray-700">City</label>
					<Input
						name="city"
						value={city}
						onChange={handleChange}
						onBlur={handleBlur}
						className="mt-1 block w-full"
					/>
				</div>

				<div className="flex-1">
					<label className=" mb-1 block text-sm  text-gray-700">State</label>
					<Input
						name="region"
						value={region}
						onChange={handleChange}
						onBlur={handleBlur}
						className="mt-1 block w-full"
					/>
				</div>

				<div className="flex-1">
					<label className=" mb-1 block text-sm  text-gray-700">Postcode</label>
					<Input
						name="postcode"
						value={postcode}
						onChange={handleChange}
						onBlur={handleBlur}
						className="mt-1 block w-full"
					/>
				</div>

				<div className="flex-1">
					<label className=" mb-1 block text-sm  text-gray-700">Country</label>
					<Input
						name="country"
						value={country}
						onChange={handleChange}
						onBlur={handleBlur}
						className="mt-1 block w-full"
					/>
				</div>
			</div>
		</div>
	);
};

export default LocationFreeForm;
